import React from 'react';
import { Container, Typography, Box, Paper, Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';

const PolicyLayout = ({ title, lastUpdated, children }) => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc', py: 4 }}>
      <Container maxWidth="md">
        <Breadcrumbs sx={{ mb: 3 }}>
          <MuiLink component={Link} to="/" underline="hover" color="inherit">
            Home
          </MuiLink>
          <Typography color="text.primary">{title}</Typography>
        </Breadcrumbs>

        <Paper sx={{ p: { xs: 3, md: 5 }, borderRadius: 2 }}>
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{ fontWeight: 'bold', color: '#1a202c', mb: 2 }}
          >
            {title}
          </Typography>

          {lastUpdated && (
            <Typography
              variant="body2"
              sx={{ color: '#718096', mb: 4, fontStyle: 'italic' }}
            >
              Last Updated: {lastUpdated}
            </Typography>
          )}

          <Box sx={{
            '& h2': {
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: '#1a202c',
              mt: 4,
              mb: 2
            },
            '& h3': {
              fontSize: '1.25rem',
              fontWeight: 'bold',
              color: '#2d3748',
              mt: 3,
              mb: 1.5
            },
            '& p': {
              color: '#4a5568',
              lineHeight: 1.7,
              mb: 2
            },
            '& ul, & ol': {
              color: '#4a5568',
              lineHeight: 1.8,
              pl: 3,
              mb: 2
            },
            '& li': {
              mb: 1
            },
            '& a': {
              color: '#1976d2',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline'
              }
            }
          }}>
            {children}
          </Box>
        </Paper>

        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: '#718096' }}>
            Questions about this policy? Contact us at{' '}
            <MuiLink href="mailto:legal@appealbot.com">legal@appealbot.com</MuiLink>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default PolicyLayout;
